<template>
    <div class="contents">
        <div class="case">
            <div class="title">客户合作案例</div>
            <div class="write">CASE OF CUSTOMER COOPERATION</div>
            <!-- 手机 -->
            <div class="ports">
                <div class="port-list">
                    <div class="list"><img src="./images/phone/YouFuBao.png" alt=""></div>
                    <div class="item" @click="off1 = !off1">游付宝</div>
                </div>
                <div class="port-list">
                    <div class="list"><img src="./images/phone/WeiMoKe.png" alt=""></div>
                    <div class="item" @click="off2 = !off2">微摩客</div>
                </div>
                <div class="port-list">
                    <div class="list"><img src="./images/phone/JiangMei.png" alt=""></div>
                    <div class="item" @click="off3 = !off3">将美科技</div>
                </div>
                <div class="back-stage" :class="{push:off1}">
                    <div class="close"><img src="../../assets/phone/close.svg" alt="" @click="off1 = !off1"></div>
                    <div class="back-item" >
                            <div class="number"><img src="./images/01.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
                                <div class="titleone">
                                    游付宝<br/>让每个游艺门店，都可以有自己的品牌
                                </div>
                                <div class="writeone">CUSTOMER CASES</div>
                                <div class="section">
                                    <p>游付宝专为游艺门店提供管理、营销、服务一站式智能解决方案。基于独有的移动支付设备，在各个环节中注入互联网基因，颠覆传统的管理运营方式，匠心打造，是一个融合了全新技术与运营体系的线上平台。</p>
                                    <p>平台帮助游艺门店从业者在门店选址、潜客挖掘、活动运营等方面提供准确的决策依据，同时也给予会员更贴心的服务、更实惠的价格。</p>
                                </div>
                                <div class="line"></div>
                                <div class="right">
                                    <img src="./images/youfubao.png" alt="" oncontextmenu="return false;" onselectstart="return false;">
                                </div>
                    </div>
              </div>
              <div class="back-stage" :class="{push:off2}">
                    <div class="close"><img src="../../assets/phone/close.svg" alt="" @click="off2 = !off2"></div>
                    <div class="back-item" >
                                    <div class="number"><img src="./images/02.png" alt=""></div>
                                    <div class="titleone">
                                        <p>微摩客</p>
                                        <p>享于身，奢于心</p>
                                    </div>
                                    <div class="writeone">CUSTOMER CASES</div>
                                <div class="section">
                                    <p>微摩客是广州微摩客科技有限公司秉承着“享于身，奢于心“为理念，结合了共享经济模式和市场需求所打造的共享按摩椅服务平台。本平台旨在为商家和顾客服务，为大家专业地解决关于共享按摩椅的消费体验、合作加盟等的相关问题。</p>
                                    <p>微摩客把按摩服务便捷化、优惠化以及实时化。商场、酒店、机场、高铁、酒楼、KTV等，在各样的场所都可放置共享按摩椅，用户随到随用！按摩椅使用简单方便，用户只需扫码支付，就能够立即启动，体验极佳。</p>
                                </div>
                                <div class="line"></div>
                                <div class="right">
                                    <img src="./images/weimoke.png" alt="">
                                </div>
                    </div>
              </div>
              <div class="back-stage" :class="{push:off3}">
                    <div class="close"><img src="../../assets/phone/close.svg" alt="" @click="off3 = !off3"></div>
                    <div class="back-item" >
                            <div class="number"><img src="./images/03.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
                                <div class="titleone">
                                    将美科技
                                </div>
                                <div class="writeone">CUSTOMER CASES</div>
                                <div class="section">
                                    <p>广州将美信息科技有限公司专业从事共享麻将机平台架设、麻将文化推广、产品经营销售等，是国内首家共享麻将机研究推广的企业，公司内部技术开发团队资历深厚，服务团队经验丰富，管理体系严谨、完善。</p>
                                    <p>将美结合社会的需求和趋势，搭建了国内首个共享麻将桌服务平台，并提出了“E³-mahjong”娱乐区域的概念。众所周知，共享麻将桌的优势是轻松支付、价格实惠、即时享受，“E³-mahjong”娱乐区代表的也正是一种环境和氛围，是为了能让每个人都能够轻松快捷地享受麻将的乐趣而提出的。</p>
                                </div>
                                <div class="line"></div>
                                <div class="right">
                                <img src="./images/jiangmei.png" alt="" oncontextmenu="return false;" onselectstart="return false;">
                            </div>                               
                    </div>
              </div>
            </div>
            <!-- 电脑 -->
            <div class="port">
                <div class="swiper-container" ref="swiper" >  
                    <div class="swiper-wrapper" id="swiperwrapper"> 
                        <div class="swiper-slide swiper-no-swiping">
                            <div class="youfubao">
                                <div class="left">
                                    <div class="number"><img src="./images/01.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
                                    <div class="titleone">
                                        游付宝<br/>让每个游艺门店，都可以有自己的品牌
                                    </div>
                                    <div class="writeone">CUSTOMER CASES</div>
                                    <div class="section">
                                        <p>游付宝专为游艺门店提供管理、营销、服务一站式智能解决方案。基于独有的移动支付设备，在各个环节中注入互联网基因，颠覆传统的管理运营方式，匠心打造，是一个融合了全新技术与运营体系的线上平台。</p>
                                        <p>平台帮助游艺门店从业者在门店选址、潜客挖掘、活动运营等方面提供准确的决策依据，同时也给予会员更贴心的服务、更实惠的价格。</p>
                                    </div>
                                    <div class="fix">
                                        <div class="line"></div>
                                        <div class="direct">
                                            <div class="direct-left" @click="prev()"></div>
                                            <div class="direct-right" @click="next()"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="right">
                                    <img src="./images/youfubao.png" alt="" oncontextmenu="return false;" onselectstart="return false;">
                                </div>
                            </div>
                        </div>
                        <div class="swiper-slide swiper-no-swiping">
                            <div class="weimoke">
                                <div class="right">
                                    <img src="./images/weimoke.png" alt="" oncontextmenu="return false;" onselectstart="return false;">
                                </div>
                                <div class="left">
                                        <div class="number"><img src="./images/02.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
                                        <div class="titleone">
                                            <p>微摩客</p>
                                            <p>享于身，奢于心</p>
                                        </div>
                                        <div class="writeone">CUSTOMER CASES</div>
                                    <div class="section">
                                        <p>微摩客是广州微摩客科技有限公司秉承着“享于身，奢于心“为理念，结合了共享经济模式和市场需求所打造的共享按摩椅服务平台。本平台旨在为商家和顾客服务，为大家专业地解决关于共享按摩椅的消费体验、合作加盟等的相关问题。</p>
                                        <p>微摩客把按摩服务便捷化、优惠化以及实时化。商场、酒店、机场、高铁、酒楼、KTV等，在各样的场所都可放置共享按摩椅，用户随到随用！按摩椅使用简单方便，用户只需扫码支付，就能够立即启动，体验极佳。</p>
                                    </div>
                                    <div class="fix">
                                        <div class="line"></div>
                                        <div class="direct">
                                            <div class="direct-left" @click="prev1()"></div>
                                            <div class="direct-right" @click="next1()"></div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div class="swiper-slide swiper-no-swiping">
                            <div class="jiangmei">
                                <div class="left">
                                    <div class="number"><img src="./images/03.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
                                    <div class="titleone">
                                        将美科技
                                    </div>
                                    <div class="writeone">CUSTOMER CASES</div>
                                    <div class="section">
                                        <p>广州将美信息科技有限公司专业从事共享麻将机平台架设、麻将文化推广、产品经营销售等，是国内首家共享麻将机研究推广的企业，公司内部技术开发团队资历深厚，服务团队经验丰富，管理体系严谨、完善。</p>
                                        <p>将美结合社会的需求和趋势，搭建了国内首个共享麻将桌服务平台，并提出了“E³-mahjong”娱乐区域的概念。众所周知，共享麻将桌的优势是轻松支付、价格实惠、即时享受，“E³-mahjong”娱乐区代表的也正是一种环境和氛围，是为了能让每个人都能够轻松快捷地享受麻将的乐趣而提出的。</p>
                                    </div>
                                    <div class="fix">
                                        <div class="line"></div>
                                        <div class="direct">
                                            <div class="direct-left" @click="prev2()"></div>
                                            <div class="direct-right" @click="next2()"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="right">
                                    <img src="./images/jiangmei.png" alt="" oncontextmenu="return false;" onselectstart="return false;">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name:'case',
  data(){
      return{
          index: 1,
          off1:false,
          off2:false,
          off3:false,
          mySwiper: ''
      }
  },
  mounted () {
      var that = this;
      this.mySwiper = new Swiper('.swiper-container',{
            speed:300,
            slidePerView:1,
            loop:true,
            resistanceRatio:0,
            noSwiping:true,
            autoplay: {
                delay:5000,
                disableOnInteraction:false,
            },
            on:{
                slideChangeTransitionStart: function(){
                that.index = this.realIndex +1; 
                }
            }
        });
  },
  methods:{
      // 向前
      prev(){
          this.mySwiper.slideToLoop(2, 500, false);
      },
      //向后
    next(){
        this.mySwiper.slideToLoop(1, 500, false);
    },
    prev1(){
        this.mySwiper.slideToLoop(0, 500, false);
      },
      //向后
    next1(){
        this.mySwiper.slideToLoop(2, 500, false);
    },
    prev2(){
        this.mySwiper.slideToLoop(1, 500, false);
      },
      //向后
    next2(){
        this.mySwiper.slideToLoop(0, 500, false);
    },
  }
}
</script>

<style scoped>
@import '../../assets/swiper-4.2.0.min.css';
.swiper-slide{transition-duration: 600ms;}
.ports{
    display: none;
}
.contents{
    width:100%;
    /* height: 100vh; */
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.case{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.title{
    font-family: 微软雅黑;
font-size: 50px;
font-weight: normal;
font-stretch: normal;
letter-spacing: 5px;
color: #333;
height: 50px;
line-height: 50px;
margin-top:108px;
}
.write{
    height: 15px;
    line-height: 15px;
font-family: Arial;
font-size: 14px;
letter-spacing: 1px;
color: #333333;
margin-top:20px;
}
.port{
width: 1253px;
height: 576px;
margin-top:52px;
margin-bottom: 36px;
}
.fix{
    width: 511px;
    height: 43px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.line{
    width: 370px;
	height: 3px;
	background-color: #333333;
}
.direct{
    width: 90px;
	height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.direct .direct-left, .direct .direct-right{
    width: 40px;
	height: 40px;
    cursor: pointer;
}
 .direct .direct-left{
    background: url(./images/left-b.svg) no-repeat;
    background-size: cover;
}
 .direct .direct-right{
    background: url(./images/right-b.svg) no-repeat;
    background-size: cover;
}
 .direct .direct-left:hover{
    background: url(./images/left.svg) no-repeat;
    background-size: cover;
}
 .direct .direct-right:hover{
    background: url(./images/right.svg) no-repeat;
    background-size: cover;
}

.youfubao{
    width: 1253px;
/* height: 365px; */
margin-top:55px;
display: flex;
justify-content: space-between;
align-items: center;
}
.youfubao .left{
    width: 511px;
	height: 410px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
}
.youfubao .titleone{
    font-size: 30px;
	font-weight: normal;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #333333;
}
.youfubao .writeone{
    font-family: Arial;
	font-size: 14px;
	letter-spacing: 0px;
    color: #cccccc;
        display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}
.youfubao .section{
    height: 143px;
	font-family: 微软雅黑;
	font-size: 14px;
	font-weight: normal;
	line-height: 30px;
	color: #333333;
}
.youfubao .section p:nth-child(2){
    margin-top:10px;
}

.youfubao .right{
    /* width: 595px; */
	/* height: 425px; */
    width: 48%;
}
.youfubao .right img{
    width: 100%;
}

.weimoke{
    width: 1253px;
/* height: 475px; */
margin-top:55px;
display: flex;
justify-content: space-between;
align-items: center;
}
.weimoke .left{
    width: 511px;
	height: 410px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
}
.weimoke .number,.writeone{
        display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;    
}
.weimoke .titleone{
    font-size: 30px;
	font-weight: normal;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #333333;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;    
}
.weimoke .writeone{
    font-family: Arial;
	font-size: 14px;
	letter-spacing: 0px;
	color: #cccccc;
}
.weimoke .section{
    height: 192px;
	font-family: 微软雅黑;
	font-size: 14px;
	font-weight: normal;
	line-height: 30px;
	color: #333333;
}
.weimoke .section p:nth-child(2){
    margin-top:10px;
}

.weimoke .right{
    /* width: 595px;
	height: 425px; */
    width: 48%;
}
.weimoke .right img{
    width: 100%;
}

.jiangmei{
    width: 1253px;
/* height: 475px; */
margin-top:55px;
display: flex;
justify-content: space-between;
align-items: center;
}
.jiangmei .left{
    width: 511px;
	height: 410px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
}
.jiangmei .titleone{
    font-size: 30px;
	font-weight: normal;
	font-family: 微软雅黑;
	letter-spacing: 0px;
	color: #333333;
}
.jiangmei .writeone{
    font-family: Arial;
	font-size: 14px;
	letter-spacing: 0px;
    color: #cccccc;
        display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}
.jiangmei .section{
    height: 217px;
	font-family: 微软雅黑;
	font-size: 14px;
	font-weight: normal;
	line-height: 30px;
	color: #333333;
}
.jiangmei .section p:nth-child(2){
    margin-top:10px;
}

.jiangmei .right{
    /* width: 595px;
	height: 425px; */
    width:48%;
}
.jiangmei .right img{
    width: 100%;
}
@media screen and (max-width:1280px){
    .port{
        transform: scale(0.91);
    }
    /* .port,.youfubao,.weimoke,.jiangmei{
       width: 1000px;
   }
    .youfubao .right,.weimoke .right,.jiangmei .right{
    width:46%;
   } */
   
}
@media screen and (max-width:1024px){
    .port{
        transform: scale(0.8);
    }
    .contents{
        overflow-x: hidden;
    }
}
/* shouji */
@media screen and (max-width:768px){
    .port{
        display: none;
    }
    .ports{
    display: block;
    margin-top: 50px;
    margin-bottom: 50px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
    .case{
        width: 100%;
        /* height: 100%; */
        height: auto;
    }
.case .title{
font-size: 22px;
letter-spacing: 0.5px;
margin-top:50px;
color: #000;
height: 22px;
line-height: 22px;
}
.case .write{
font-size: 11px;
color: #000;
margin-top:14px;
text-align: center;
letter-spacing:0;
height: 11px;
line-height: 11px;
}
.port-list{
    width: 85%;
    position: relative;
}
.port-list .list{
    width: 100%;
}
.port-list .list img{
    width: 100%;
}
.port-list .item{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
        display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 15px;
}
.port-list:nth-child(2),.port-list:nth-child(3){
    margin-top: 20px;
}
.case .back-stage{
    width: 100%;
    height: 100%;
    background: #000;
    transition: all 0.15s linear;
    opacity: 0;
    position: fixed;
    top: 0;
    z-index: -1;
    overflow-y: auto;
}
.case .back-stage.push{
    transition: opacity 0.15s linear;
    opacity: 1;
    z-index: 99;
}
.back-stage .close{
    width: 100%;
    height: 48px;
    padding: 0px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .back-stage .back-item{
       width: 100%;
      /* height: calc(100% - 48px); */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px 32px;
    box-sizing: border-box;
    text-align: center;
    margin-bottom: 48px;
    
  }
 .back-stage .close img{
    width: 15px;
	  height: 15px;
  }
.back-item .number{
    width: 12.5px;
    height: 11px;
}
.back-item .number img{
    width: 100%;

}
.back-item .titleone{
    width: 100%;
    font-size: 17px;
	font-family:'Times New Roman', Times, serif;
	letter-spacing: 0px;
	color: #fff;
    margin-top: 18px;
    text-align: left;
}
.back-item .writeone{
    width: 100%;
	font-size: 7px;
	letter-spacing: 0px;
    color: #666;
        display: flex;
    justify-content: flex-start;
    align-items: flex-start;
     margin-top: 14px;
}
.back-item .section{
    width: 100%;
	font-family:'Times New Roman', Times, serif;
	font-size: 11px;
	line-height: 22px;
	color: #fff;
    margin-top: 18px;
}
.back-item .section p{
    text-align: justify;
}
.line{
    height: 1px;
    width: 100%;
    background: #333;
    margin: 25px 0px;
}
.back-item .right{
    width: 100%;
}
.back-item .right img{
    width: 100%;
}

}
</style>




// WEBPACK FOOTER //
// src/components/coopera/case.vue